if (!customElements.get("tabbed-info")) {
  customElements.define(
    "tabbed-info",
    class TabbedInfo extends HTMLElement {
      constructor() {
        super();

        this.tabs = this.querySelectorAll(".product__tabbed_info__tab");
        this.infos = this.querySelectorAll(".product__tabbed_info__info");

        this.addEventListener("click", this.handleClick.bind(this));
      }

      handleClick(e) {
        const target = e.target;
        if (!target.classList.contains("product__tabbed_info__tab")) return;
        this.switchTab(target);
      }

      clearTabs() {
        this.tabs.forEach((element) => {
          element.classList.remove("active");
          element.ariaExpanded = false;
        });
      }

      clearInfos() {
        this.infos.forEach((element) => {
          element.classList.remove("visible");
        });
      }

      switchTab(tab) {
        const tabNumber = tab.dataset.tab;

        this.clearTabs();
        this.clearInfos();

        tab.classList.add("active");
        tab.ariaExpanded = true;
        this.querySelector(
          `.product__tabbed_info__info[data-tab="${tabNumber}"]`
        ).classList.add("visible");
      }
    }
  );
}
